const imgTeamMotionMain = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const imgDingMotion1 = "./assets/figma/20f0a67b-abf6-424d-9f15-e926777ddbc8.png";
const imgLine21 = "./assets/figma/855ab069-959b-4910-953b-d071eec60edc.svg";
const imgArrow5 = "./assets/figma/86fee700-6c89-4ef3-a41a-21b7518ecb91.svg";
const imgEllipse30 = "./assets/figma/41ce7cbc-9b41-40ee-9c06-364b54d50aa8.svg";
const imgEllipse31 = "./assets/figma/d27fadb5-aee3-4dff-9695-28e6d66364df.svg";
const imgEllipse32 = "./assets/figma/ed5ea105-a6bc-483e-81db-399582044736.svg";
const img1 = "./assets/figma/beaf3898-09ae-4b77-8dd1-0533e6feca91.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgEllipse37 = "./assets/figma/913dc448-4698-43da-9d8b-57b058da291a.svg";

export default function TeamMotionMain() {
  return (
    <div className="s0 s1" data-node-id="875:2791" data-name="TEAM_MOTION_MAIN">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <img alt="" className="s2 s9 s105 s258 s1" src={imgTeamMotionMain} />
      </div>
      <div className="s106 s259 s2 s126 s260 s261" data-node-id="1013:10" data-name="DING_MOTION 1">
        <img alt="" className="s2 s3 s9 s262 s4 s1" src={imgDingMotion1} />
      </div>
      <div className="s2 s263 s264 s265 s266" data-node-id="886:6" data-name="DINGAI_MOTION 1" />
      <div className="s2 s267 s268 s269 s270" data-node-id="875:2797" data-name="image 14" />
      <div className="s259 s2 s16 s17 s24 s271 s18 s19 s272 s273 s274 s275 s276 s145 s146 s277 s278" data-node-id="875:2820">
        <div aria-hidden className="s2 s147 s3 s4 s145" />
        <div className="s16 s17 s24 s279 s26 s0 s28 s280" data-node-id="875:2821">
          <p className="s23 s31 s32 s27 s0 s28 s29 s281 s34" data-node-id="875:2822">
            MOTION AI RECIPE
          </p>
          <div className="s46 s0 s28 s34" data-node-id="875:2823">
            <div className="s2 s48">
              <img alt="" className="s49 s9 s1" src={imgLine21} />
            </div>
          </div>
        </div>
        <a className="s282 s16 s141 s17 s24 s283 s284 s18 s42 s285 s286 s287 s0 s145 s146 s28 s288 s289 s290" data-node-id="875:2824">
          <div className="s16 s17 s18 s19 s0 s28 s34" data-node-id="875:2825">
            <p className="s23 s31 s32 s27 s0 s28 s29 s37 s149 s54" data-node-id="875:2826">
              ARCHIVE
            </p>
            <div className="s46 s0 s28 s291" data-node-id="875:2827">
              <div className="s2 s292">
                <img alt="" className="s49 s9 s1" src={imgArrow5} />
              </div>
            </div>
          </div>
        </a>
        <div className="s2 s3 s4 s150 s151" />
      </div>
      <div className="s2 s16 s17 s24 s293 s294 s26 s295 s296 s297" data-node-id="875:2828">
        <div className="s16 s17 s298 s18 s0 s28 s34" data-node-id="875:2829">
          <div className="s0 s28 s299" data-node-id="875:2830">
            <div className="s2 s300">
              <img alt="" className="s49 s9 s1" src={imgEllipse30} />
            </div>
          </div>
          <p className="s23 s301 s302 s32 s27 s0 s28 s29 s281 s54" data-node-id="875:2831">
            CHATGPT
          </p>
        </div>
        <div className="s16 s17 s298 s18 s0 s28" data-node-id="875:2832">
          <div className="s0 s28 s299" data-node-id="875:2833">
            <div className="s2 s300">
              <img alt="" className="s49 s9 s1" src={imgEllipse31} />
            </div>
          </div>
          <p className="s23 s301 s302 s32 s27 s0 s28 s29 s281 s54" data-node-id="875:2834">
            MIDJOURNEY
          </p>
        </div>
        <div className="s16 s17 s298 s18 s0 s28" data-node-id="875:2835">
          <div className="s0 s28 s299" data-node-id="875:2836">
            <div className="s2 s300">
              <img alt="" className="s49 s9 s1" src={imgEllipse32} />
            </div>
          </div>
          <p className="s23 s301 s302 s32 s27 s0 s28 s29 s281 s54" data-node-id="875:2837">
            KLING
          </p>
        </div>
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s107 s108 s109" data-node-id="1018:230" data-name="navigationbar">
        <a className="s16 s141 s17 s110 s26 s0 s28" data-node-id="1018:231">
          <div className="s111 s0 s28 s112" data-node-id="1018:232" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="1018:237">
            DING AI LAB
          </p>
        </a>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="1018:238">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="1018:239">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="1018:240">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="1018:241">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="1018:242">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="1018:243">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="1018:244">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s124" data-node-id="1018:245">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="1018:246">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="1018:247">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </div>
        </div>
      </div>
      <div className="s259 s2 s16 s17 s24 s230 s26 s303 s277 s304" data-node-id="1018:266" data-name="TAB_TEAM">
        <a className="s16 s141 s17 s305 s18 s306 s307 s308 s309 s0 s145 s146 s28 s304" data-node-id="1018:267" data-name="TAB_TEAM_GRAPHIC2">
          <div aria-hidden className="s2 s147 s3 s4 s145" />
          <p className="s23 s31 s310 s32 s27 s0 s28 s29 s281 s149 s119" data-node-id="1018:268">
            GRAPHIC 1
          </p>
          <div className="s2 s3 s4 s150 s151" />
        </a>
        <a className="s16 s141 s17 s305 s18 s306 s307 s308 s309 s0 s145 s146 s28 s34" data-node-id="875:2808" data-name="TAB_TEAM_GRAPHIC2">
          <div aria-hidden className="s2 s147 s3 s4 s145" />
          <p className="s23 s31 s310 s32 s27 s0 s28 s29 s281 s149 s119" data-node-id="875:2809">
            GRAPHIC 2
          </p>
          <div className="s2 s3 s4 s150 s151" />
        </a>
        <a className="s16 s141 s17 s24 s305 s26 s42 s311 s307 s312 s309 s0 s145 s146 s28 s34" data-node-id="1018:273" data-name="TAB_TEAM_UI/UX">
          <div aria-hidden className="s2 s313 s3 s4 s145" />
          <div className="s16 s17 s314 s18 s19 s0 s28 s315" data-node-id="1018:274">
            <p className="s23 s31 s32 s27 s0 s28 s29 s281 s149 s54" data-node-id="1018:275">
              UI/UX
            </p>
          </div>
          <div className="s2 s3 s4 s150 s151" />
        </a>
        <a className="s16 s141 s17 s305 s18 s311 s307 s316 s309 s0 s145 s146 s28 s34" data-node-id="1018:276" data-name="TAB_TEAM_PACKAGE">
          <div aria-hidden className="s2 s147 s3 s4 s145" />
          <p className="s23 s31 s32 s27 s0 s28 s29 s281 s149 s54" data-node-id="1018:277">
            PACKAGE
          </p>
          <div className="s2 s3 s4 s150 s151" />
        </a>
        <div className="s16 s81 s17 s305 s18 s306 s307 s317 s309 s0 s145 s28 s34" data-node-id="875:2816" data-name="TAB_TEAM_MOTION">
          <div aria-hidden className="s2 s152 s3 s4 s145" />
          <div className="s16 s17 s18 s19 s0 s28 s318" data-node-id="875:2817">
            <p className="s23 s31 s310 s32 s27 s0 s28 s29 s281 s319" data-node-id="875:2818">
              motion
            </p>
            <div className="s0 s28 s320" data-node-id="875:2819">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgEllipse37} />
            </div>
          </div>
          <div className="s2 s3 s4 s150 s151" />
        </div>
      </div>
    </div>
  );
}